import { render } from "./TitleCard.vue?vue&type=template&id=ba16a6e8&scoped=true"
import script from "./TitleCard.vue?vue&type=script&lang=js"
export * from "./TitleCard.vue?vue&type=script&lang=js"

import "./TitleCard.vue?vue&type=style&index=0&id=ba16a6e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba16a6e8"]])

export default __exports__